import { useModal } from "@services/ModalContext";
import classNames from "classnames";
import { NewExamineeStepNames } from "../../store/newExamineeSlice";
import styles from "./NewAssessmentBody.module.css";

export const BodyHeader = (): JSX.Element => {
    const breadcrumb = classNames("is-size-7", "mx-4", styles.breadcrumbText);

    const { formName } = useModal();

    return (
        <div className="breadcrumb has-arrow-separator mb-3">
            <ul className="is-justify-content-center is-align-items-center">
                <li>
                    <p
                        className={`${breadcrumb} ${
                            formName === NewExamineeStepNames.ContactInfo ? styles.current : ""
                        }`}
                    >
                        Contact Info
                    </p>
                </li>
                <li>
                    <p className={`${breadcrumb} ${formName === NewExamineeStepNames.Details ? styles.current : ""}`}>
                        Details
                    </p>
                </li>
                <li>
                    <p
                        className={`${breadcrumb} ${
                            formName === NewExamineeStepNames.AssignedTo ? styles.current : ""
                        }`}
                    >
                        Assigned To
                    </p>
                </li>
            </ul>
        </div>
    );
};
